import * as React from "react";
import { Text, Button } from "@uikit";
import { Review } from "@kalabo/golfsavers-common";
import dayjs from "dayjs";
import StarRating from "../starRating";

interface IProps {
  data?: Review[];
}

const Reviews = ({ data = [] }: IProps) => {
  const [visible, setVisible] = React.useState(10);
  return (
    <div className="mb-24">
      <Text
        size={17}
        leading={1.3}
        weight="semibold"
        element="h2"
        className="pb-0 mt-8"
      >
        Latest Reviews
      </Text>
      {data
        .sort((a, b) => {
          if (a.created_at > b.created_at) return -1;
          return 1;
        })
        .slice(0, visible)
        .map((review: Review) => (
          <div className="p-[15px] mt-[15px] bg-grey rounded-lg">
            <div>
              <div className="flex justify-between items-center mb-4">
                <div className="flex">
                  <StarRating
                    color="green"
                    rating={review.rating}
                    hideCount
                    size="medium"
                  />
                </div>
                <div>
                  <Text size={12} leading={1.5} color="black60">
                    {dayjs(review.created_at).format("MMM DD, YYYY")}
                  </Text>
                </div>
              </div>
            </div>
            <Text
              size={15}
              leading={1.3}
              weight="semibold"
              element="h3"
              className="mb-[10px]"
            >
              {review.title}
            </Text>
            <Text size={15} leading={1.3} element="p" color="black80">
              {review.review}
            </Text>
            <Text size={12} leading={1.5} color="black60">
              {review.name}
            </Text>
          </div>
        ))}
      {visible <= data.length && (
        <div className="mt-4">
          <Button
            text="Load more reviews"
            color="grey7"
            invert
            size="medium"
            className="!w-full lg:!w-auto !px-4 !mb-0"
            onClick={() => {
              setVisible((prevValue) => prevValue + 10);
            }}
          />
        </div>
      )}
    </div>
  );
};
export default Reviews;
